import './featuredspeakers.less'

import {Background, Image} from '@codeurs/front'
import FwddiveTextWhite from 'assets/images/logos/fwddive-text-white.svg'
import ItfbelgiumTextWhite from 'assets/images/logos/itfbelgium-text-white.svg'
import TinyaiTextWhite from 'assets/images/logos/tinyai-text-white.svg'
import React from 'react'
import {ImageType, LinkType, SummitType, WysiwygType} from 'types'
import {useEvent} from 'util/eventcontext'
import {style} from 'util/style'
import {Summitlogo} from 'views/layout/summitlogo'
import {ProgramLink} from 'views/program/programlink'
import {Theme} from 'views/theme'

const styles = style('featuredspeakers', ['item'])

export type FeaturedspeakersType = {
	title?: string
	link?: LinkType
	items: Array<FeaturedspeakersItemType>
}

export type FeaturedspeakersItemType = {
	image?: ImageType
	firstname?: string
	lastname: string
	company?: string
	text?: WysiwygType
	logo?: SummitType | Array<SummitType>
	link?: LinkType
}

export const Featuredspeakers: React.FC<FeaturedspeakersType> = ({
	title,
	link,
	items
}) => {
	return (
		<div className={styles()}>
			<Theme.OuterContainer>
				<Theme.Container>
					{(title || link) && (
						<div className={styles('top')}>
							<div className={styles('top-container')}>
								{title && <Theme.H1 as="h2">{title}</Theme.H1>}
								{link && link.url && (
									<div className={styles('top-link')}>
										<Theme.Link to={link.url}>
											<Theme.LinkText>
												{link.description || link.title}
											</Theme.LinkText>
											<Theme.LinkIcon icon="arrow-long" />
										</Theme.Link>
									</div>
								)}
							</div>
						</div>
					)}
					{items && items.length !== 0 && (
						<div className={styles('items')}>
							{items.map((item, i) => (
								<div className={styles('items-item')}>
									<FeaturedspeakersItem key={i} {...item} />
								</div>
							))}
						</div>
					)}
				</Theme.Container>
			</Theme.OuterContainer>
		</div>
	)
}

export const FeaturedspeakersItem: React.FC<FeaturedspeakersItemType> = ({
	image,
	firstname,
	lastname,
	company,
	text,
	logo = [],
	link
}) => {
	const {program} = useEvent()
	const item = program.getProgramItemFromLink(link)
	const summits = typeof logo === 'string' ? [logo] : logo

	return (
		<div className={styles.item().mod({text})}>
			<ProgramLink item={item}>
				<div className={styles.item('flex')}>
					<div className={styles.item('left')}>
						{text && (
							<div className={styles.item('left-text')}>
								<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
							</div>
						)}
					</div>
					<div className={styles.item('right')}>
						<div className={styles.item('right-image')}>
							<div className={styles.item('right-image-bg')}>
								{image && !image.empty && <Background img={image} />}
							</div>
							<div className={styles.item('right-image-overlay')} />
						</div>
						<div className={styles.item('right-content')}>
							{(firstname || lastname) && (
								<p className={styles.item('right-content-name')}>
									{firstname + ' ' + lastname}
								</p>
							)}
							{company && (
								<p className={styles.item('right-content-company')}>
									{company}
								</p>
							)}
						</div>
					</div>
				</div>
				{summits.length && (
					<div className={styles.item('summit')}>
						{summits.map(summit => (
							<Summitlogo summit={summit} />
						))}
					</div>
				)}
			</ProgramLink>
		</div>
	)

	function switchLogo(summitLogo) {
		switch (summitLogo) {
			case 'itfbelgium':
				return <Image {...ItfbelgiumTextWhite} alt="ITF Belgium" />
			case 'fwddive':
				return <Image {...FwddiveTextWhite} alt="Forward Dive" />
			case 'tinyai':
				return <Image {...TinyaiTextWhite} alt="Tiny AI" />
			default:
				return null
		}
	}
}
